import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/partials/plasterify.scss';

const propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const Plasterify = ({ children, className }) => {
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            {children}
            <div className={classNames([styles.plaster, styles.vertical])} />
            <div className={classNames([styles.plaster, styles.horizontal])} />
            <div className={classNames([styles.plaster, styles.vertical])} />
        </div>
    );
};

Plasterify.propTypes = propTypes;
Plasterify.defaultProps = defaultProps;

export default Plasterify;
